import { Box, Flex } from '@amzn/ring-ui-react-components';
import { BaseOptionType } from './types';
import { Checkbox } from '../Form';
import type { OptionProps as RSOptionProps } from 'react-select';

export interface OptionProps<
  OptionType extends BaseOptionType,
  IsMulti extends boolean = boolean,
> extends RSOptionProps<OptionType, IsMulti> {}

export const Option = <
  OptionType extends BaseOptionType,
  IsMulti extends boolean,
>({
  data,
  innerProps,
  innerRef,
  isMulti,
  isSelected,
  isFocused,
}: OptionProps<OptionType, IsMulti>) => (
  <Flex
    {...innerProps}
    alignItems="center"
    color="neutral.500"
    cursor="pointer"
    px={3}
    py={3}
    ref={innerRef}
    textStyle="body-normal-medium"
    userSelect="none"
    width="100%"
    backgroundColor={isFocused ? 'primary.100' : 'none'}
    _hover={{
      backgroundColor: !isMulti ? 'primary.100' : 'primary.500',
    }}
  >
    {isMulti && <Checkbox checked={isSelected} mr={2} size="lg" />}
    <Box as="label">{data.label}</Box>
  </Flex>
);
